import { webapi } from '@/api/webapi.ts';
import { cancelBulkTradeRfs } from '@/store/bulkTrade/api/cancelBulkTradeRfs.ts';
import { checkBulkTradeByTradeCapture } from '@/store/bulkTrade/api/checkBulkTradeByTradeCapture.ts';
import { executeBulkTradeRfs } from '@/store/bulkTrade/api/executeBulkTradeRfs.ts';
import { requestBulkTradeRfs } from '@/store/bulkTrade/api/requestBulkTradeRfs.ts';

export const bulkTradeApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    checkBulkTradeByTradeCapture: checkBulkTradeByTradeCapture(builder),

    requestBulkTradeRfs: requestBulkTradeRfs(builder),
    cancelBulkTradeRfs: cancelBulkTradeRfs(builder),
    executeBulkTradeRfs: executeBulkTradeRfs(builder),
  }),
});

export const { useRequestBulkTradeRfsMutation, useExecuteBulkTradeRfsMutation, useCancelBulkTradeRfsMutation } =
  bulkTradeApi;
